module.exports = __webpack_public_path__ + "static/modern-homes-white-4dd7e559a10e5bb486fae7286b0bd2dd.jpg";